import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import getContractStatus from './getContractStatus.api';
import getDocumentStatusByDocumentName from './getDocumentStatus.api';
import * as DOCUMENT_NAME from '../../constants/documentNames';
import { onlyUnique } from '../../utils/onlyUniqueArrays';

const firebaseRef = firebase.database();

export default async function getPendingDocumentStatus(
	purchaserList,
	callback
) {
	// @TODO:
	//get list of all purchaser from where we get the list of all the purchaserIds
	//loop throgh the purchaserId and get the documentInformation fron /kavtek_agreements/
	//use getContractStatus api to get the status for each agreement

	//get list of all purchaserId
	var purchaserIdArr = [];

	console.log('getPendingDocumentStatus purchaserList', purchaserList);

	if (purchaserList) {
		Object.keys(purchaserList).length !== 0 &&
			purchaserList?.forEach((purchaser) => {
				var leadId = purchaser.leadId;
				var clientFName = purchaser.clientFName;

				var leadJson = {
					leadId: leadId,
					clientFName: clientFName,
				};

				purchaserIdArr.push(leadJson);
			});
	}

	var documentStatusArr = [];

	purchaserIdArr.forEach(async (purchaser) => {
		var documentExtraSubjectArr = [];

		await firebaseRef
			.ref(
				'/kavtek_agreements/' +
					PROJECT_CODE.projectCode +
					'/' +
					purchaser.leadId +
					'/documentInformation/signatureRequestsExtras'
			)
			.once('value', (snapshot) => {
				var sigReqExtraObj = snapshot.val();

				console.log('sigReqExtraObj', sigReqExtraObj);

				var sigReqExtraKeys =
					sigReqExtraObj && Object.keys(sigReqExtraObj);

				sigReqExtraKeys?.forEach((key) => {
					documentExtraSubjectArr.push(
						sigReqExtraObj[key]['subject']
					);
				});
			});

		console.log('documentExtraSubjectArr', documentExtraSubjectArr);

		var uniqueSubject = documentExtraSubjectArr.filter(onlyUnique);
		console.log('documentExtraSubjectArr uniqueSubject', uniqueSubject);

		await getDocumentStatusByDocumentName(
			purchaser.leadId,
			DOCUMENT_NAME.aps,
			(returned) => {
				returned['leadId'] = purchaser.leadId;

				if (
					returned.eventType !== 'signature_request_canceled' &&
					returned.status !== 'builder_signed'
				) {
					if (!returned.eventType) {
						returned['eventType'] = 'signature_request_sent';
					}
					if (!returned.status) {
						returned['status'] = 'buyer_to_sign';
					}

					if (returned.status === 'client_signed') {
						returned['status'] = 'builder_to_sign';
					}
					console.log('getPendingDocumentStatus onlyyy', returned);
					documentStatusArr.push(returned);
				}
			}
		);

		documentExtraSubjectArr?.forEach(async (subject) => {
			await getDocumentStatusByDocumentName(
				purchaser.leadId,
				subject,
				(returned) => {
					returned['leadId'] = purchaser.leadId;
					if (
						returned?.extras[0]?.statusCode !== 'signed' &&
						returned?.extras[0]?.statusCode !== 'signed' &&
						returned?.extras[0]?.statusCode !== 'signed'
					) {
						if (
							returned.eventType !== 'signature_request_canceled'
						) {
							console.log(
								'returned.status',
								returned.extras[0]?.statusCode
							);
							if (returned.extras[0]?.statusCode !== 'signed') {
								returned['status'] = 'buyer_to_sign';
							} else if (
								returned.extras[1]?.statusCode !== 'signed'
							) {
								returned['status'] = 'buyer_to_sign';
							} else if (
								returned.extras[2]?.statusCode !== 'signed'
							) {
								returned['status'] = 'builder_to_sign';
							}
							console.log(
								'getPendingDocumentStatus extrraa',
								returned
							);
							documentStatusArr.push(returned);
						}
					}
				}
			);
		});
	});

	setTimeout(() => {
		console.log('documentStatusArrdocumentStatusArr', documentStatusArr);
		callback(documentStatusArr);
	}, 1000);
}
